
// require('jquery-touch-events');
require('lightcase');

module.exports = function () {
    $(document).ready(function () {

        $('[data-lightbox]').lightcase({
            attr:               'data-lightbox',
            transition:         'scrollHorizontal',
            showSequenceInfo:   true,
            //showCaption:      false,
            maxWidth:           1300,
            maxHeight:          900,
            overlayOpacity:     0.55
        });

    });
};



// WEBPACK FOOTER //
// ./resources/assets/js/vn/data-lightbox.js